// extracted by mini-css-extract-plugin
export default {"wrapperBtn":"CopyButton_wrapperBtn__SnCqE","button":"CopyButton_button__1GR2v"};